import { Text, ThemeUIStyleObject } from 'theme-ui';

type Props = {
  text: string | null;
  isCollectionModule?: boolean;
  forwardSx?: ThemeUIStyleObject;
};

const BadgeHighlight = ({ text, isCollectionModule, forwardSx }: Props) => {
  return (
    <div
      sx={{
        border: `1px solid ${isCollectionModule ? 'black' : 'UIGray1'}`,
        borderRadius: '.4rem',
        width: 'fit-content',
        maxHeight: '2.8rem',
        p: '.8rem',
        fontSize: '1.4rem',
        fontWeight: 450,
        lineHeight: 0.8,
        letterSpacing: '-0.01em',
        whiteSpace: 'nowrap',
        ...forwardSx,
      }}
    >
      <Text as="span">{text}</Text>
    </div>
  );
};

export default BadgeHighlight;
